export default __webpack_public_path__ + "static/media/expand.833c66a2.svg";